<div *ngIf="!!data" class="flex gap-x-[8px] px-[16px] mb-[8px]">
  <span class="text-[16px]/[26px]">{{data.index + 1}}.</span>
  <div class="grow">
    <span class="notion-numbered-list-item__text">
      @for(c of data.numbered_list_item.rich_text; track $index) {
      <app-notion-text-component [data]="c"></app-notion-text-component>
      }
    </span>
    <ng-container *ngIf="data.children">
      <ng-content></ng-content>
    </ng-container>
  </div>
</div>
